<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          style="margin-left:10px;width:90px"
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          size="mini"
          @click="addInfo"
        >
          新增
        </el-button>
      </div>
      <div class="search_box">
        <el-input
          size="mini"
          clearable
          v-model.trim="searchParams.personInChargeNickname"
          placeholder="请输入负责人"
        ></el-input>
        <el-button
          style="margin-left:10px;width:90px"
          type="primary"
          plain
          icon="el-icon-search"
          size="mini"
          @click="searchList"
        >
          搜索
        </el-button>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="canteenList"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="食堂名称"
            align="center"
            prop="diningRoomName"
          >
          </el-table-column>
          <el-table-column label="经营模式" align="center" prop="businessModel">
            <template slot-scope="rowData">
              <span>{{
                canteenManagementPattern[rowData.row.businessModel].nameOne
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="上年度综合等级"
            align="center"
            prop="businessModel"
          >
            <template slot-scope="rowData">
              <span
                :style="
                  'color:' + colors[rowData.row.lastYearComprehensiveGrade - 1]
                "
                >{{
                  $Common.getDataName(
                    inspectLevel,
                    rowData.row.lastYearComprehensiveGrade
                  )
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="食堂负责人" align="center" prop="userName">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editInfo(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="checkInfo(scope.row)"
                      :underline="false"
                      >详情</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="deleteInfo(scope.row.id)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="staffList(scope.row.id)"
                      :underline="false"
                      >员工列表</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          :page-size="searchParams.pageSize"
          :current-page="searchParams.pageNum"
          :pager-count="5"
          layout="total, prev, pager, next, jumper"
          @current-change="currentChange"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="drawerTitle"
      :visible.sync="showBox"
      direction="ltr"
      :append-to-body="true"
      @close="drawerClose"
      size="40%"
      width="800px"
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >

      <canteen-add-or-edit
        :type="type"
        :defaultData="infoData"
        :showBox="showBox"
        @saveSubmit="saveSubmit"
        @cencelSubmit="cencelSubmit"
      ></canteen-add-or-edit>
      
    </el-dialog>
    <el-dialog
      title="员工信息"
      :visible.sync="staffShow"
      width="80%"
      :modal-append-to-body="false"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="staffHandleClose"
    >
      <staff-list :id="id"></staff-list>
    </el-dialog>
  </div>
</template>
<script>
import CanteenArchives from "@/components/CanteenArchives";
import CanteenAddOrEdit from "./components/CanteenAddOrEdit";
import StaffList from "./StaffList";
export default {
  name: "CanteenList",
  data() {
    return {
      total: 0,
      searchParams: {
        personInChargeNickname: "",
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1
      },
      colors: ["#12CF28", "#122ECF", "#E01616"],
      showDialog: false, //是否显示修改或新增弹窗
      type: "", //弹窗是新增还是修改
      drawerTitle: "",
      canteenList: [],
      staffShow: false, //是否显示员工列表弹窗
      id: "", //食堂id
      showBox: false,
      schooInfo:{},
      infoData: {
        diningRoomName: "餐厅", //食堂名称
        diningRoomAddress: "", //食堂地址
        securityTeamInCharge: "", //所属安全小组管制 id(不选择的时候给个0)
        schoolId: this.$store.state.schoolId, //所属学校
        usableArea: "", //食堂面积
        canteenEmployees: "", //员工数量
        numberCamerasCanteen: "", //摄像头数量
        businessModel: "", //经营模式0.自主营业 1.对外承包2.配餐3.其他
        kitchenGasUsage: "", //厨房用气情况0.天然气(管道煤气)1.瓶装气2.电磁炉3.气电合用4.其他
        canteenManagerId: "", //食堂负责人id(负责人不选择的时候给个0)
        lastYearComprehensiveGrade: "", //上年度综合等级 0.A1.B2.C
        checkDynamicLevel: "", //本次检查动态等级0.A1.B2.C
        diningRoomPhotograph: "", //食堂照片
        foodTradePermit: "" //食品经营许可证
      }
    };
  },
  computed: {
    canteenManagementPattern() {
      return this.$store.state.select.canteenManagementPattern; //经营模式
    },
    inspectLevel() {
      return this.$store.state.select.inspectLevel; //上年度综合等级
    }
  },
  created() {},
  mounted() {
    this.getCanteenList();
  },
  methods: {
    async getSchoolInfo() {
      var requestData = {
        schoolId: this.schoolId
      };
      let res = await this.$Http.getSchoolInfo(requestData, true);
      if (res.code == 200) {
        // console.log(res.data)
        this.schooInfo = res.data
        this.infoData.diningRoomAddress=res.data.schoolName
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.msg,
          type: "error"
        });
      }
    },
    searchList() {
      this.searchParams.pageNum = 1
      this.getCanteenList();
    },
    addInfo() {
      this.showBox = true;
      this.type = "add";
      this.drawerTitle = "新增食堂信息";
    },
    currentChange(val) {
      this.searchParams.pageNum = val;
      this.getCanteenList();
    },
    clearData() {
      this.infoData = {
        diningRoomName: "餐厅", //食堂名称
        diningRoomAddress:  this.schooInfo.schoolName, //食堂地址
        securityTeamInCharge: "", //所属安全小组管制 id(不选择的时候给个0)
        schoolId: this.$store.state.schoolId, //所属学校
        usableArea: "", //食堂面积
        canteenEmployees: "", //员工数量
        numberCamerasCanteen: "", //摄像头数量
        businessModel: "", //经营模式0.自主营业 1.对外承包2.配餐3.其他
        kitchenGasUsage: "", //厨房用气情况0.天然气(管道煤气)1.瓶装气2.电磁炉3.气电合用4.其他
        canteenManagerId: "", //食堂负责人id(负责人不选择的时候给个0)
        lastYearComprehensiveGrade: "", //上年度综合等级 0.A1.B2.C
        checkDynamicLevel: "", //本次检查动态等级0.A1.B2.C
        diningRoomPhotograph: "", //食堂照片
        foodTradePermit: "" //食品经营许可证
      };
    },
    // 获取食堂列表
    async getCanteenList() {
      let self = this;
      let res = await self.$Http.getCanteenList(self.searchParams);
      if (res.code == 200) {
        let data = res.data.list || [];
        data.forEach((element) => {
          element.srcList = [
            self.$store.state.config.fileUrl + element.diningRoomPhotograph,
            self.$store.state.config.fileUrl + element.foodTradePermit
          ];
        });
        self.canteenList = data;
        self.total = res.data.total || 0;
      } else if (res.code == 101) {
        self.canteenList = [];
      } else {
        self.canteenList = [];
        self.$message({
          type: "error",
          message: res.messsage || "食堂列表获取失败"
        });
      }
    },
    // 修改提交
    async deleteCanteen(id) {
      let res = await this.$Http.deleteCanteen({ id: id }, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage || "删除成功"
        });
        this.getCanteenList();
        return true;
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "删除失败"
        });
        return false;
      }
    },
    // 进行编辑当前信息
    editInfo(row) {
      this.infoData = Object.assign({}, row);
      this.showBox = true;
      this.type = "edit";
      this.drawerTitle = "编辑食堂信息";
    },
    // 查看详情
    checkInfo(row) {
      this.infoData = Object.assign({}, row);
      this.showBox = true;
      this.type = "info";
      this.drawerTitle = "食堂信息详情";
    },
    // 查看员工列表
    staffList(id) {
      if (id) {
        //   this.$router.push('./canteen_staff_list?id='+this.id)
        this.id = id;
        this.staffShow = true;
      }
    },
    staffHandleClose() {
      this.staffShow = false;
    },
    // 删除当前行
    deleteInfo(id) {
      let self = this;
      if (id) {
        self
          .$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let state = self.deleteCanteen(id);
            if (state) {
              self.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              thselfis.$message({
                type: "error",
                message: "删除失败"
              });
            }
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    drawerClose() {
      this.showBox = false;
      this.clearData();
    },
    saveSubmit(info) {
      if (this.type == "add") {
        this.addCanteen(info);
      } else if (this.type == "edit") {
        this.editCanteen(info);
      }
    },
    cencelSubmit() {
      this.showBox = false;
      this.clearData();
    },
    // 修改提交
    async editCanteen(info) {
      let res = await this.$Http.editCanteenData(Object.assign({}, info));
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage || "修改成功"
        });
        this.getCanteenList();
        this.cencelSubmit();
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "修改失败"
        });
      }
    },
    // 新增提交
    async addCanteen(info) {
      let res = await this.$Http.addCanteen(Object.assign({}, info));
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage || "新增成功"
        });
        this.getCanteenList();
        this.cencelSubmit();
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "新增失败"
        });
      }
    }
  },
  components: {
    CanteenArchives,
    CanteenAddOrEdit,
    StaffList
  }
};
</script>
